module.exports = __webpack_public_path__ + "IPS.png?c8850db7333efaaf443a3e683bfd86fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global/img/IPS.png
// module id = 25
// module chunks = 0